import type React from 'react';

type FormLayoutProps = {
  children: React.ReactNode;
  title: string | React.ReactNode;
};

export const FormLayout = ({ children, title }: FormLayoutProps) => {
  return (
    <div className=" flex h-full flex-none items-center justify-center bg-white px-4 ">
      <div className="flex w-full flex-col items-center">
        <div className="mb-6">
          <img src="https://h2.static.yximgs.com/kos/nlav12119/tXOflsnu_2026-01-28-14-05-35.svg" />
        </div>

        {/* 标题 */}
        <div className="mb-8 flex w-full flex-col items-center gap-[12px]">
          <h1 className="text-center text-[32px] font-extrabold leading-[40px] text-[#111314]">
            {title}
          </h1>
        </div>

        {/* 表单内容 */}
        <div className="flex w-[375px] flex-col gap-[2px]">{children}</div>
      </div>
    </div>
  );
};
